import React from "react";
import { Control, Controller } from "react-hook-form";
import CompetencePills, { ICompetencePillsProps } from "./CompetencePills";

interface ICompetencesControllerProps extends ICompetencePillsProps {
	control: Control<any, any>;
	name: string;
}

export const CompetencePillsController: React.FC<ICompetencesControllerProps> = ({
	control,
	name,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { ref, ...fieldWithoutRef } }) => (
				<CompetencePills {...fieldWithoutRef} {...rest} />
			)}
		/>
	);
};

export default CompetencePillsController;
